import { render, staticRenderFns } from "./RiskTrends.vue?vue&type=template&id=4d1e313d&scoped=true"
import script from "./RiskTrends.vue?vue&type=script&lang=js"
export * from "./RiskTrends.vue?vue&type=script&lang=js"
import style0 from "./RiskTrends.vue?vue&type=style&index=0&id=4d1e313d&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1e313d",
  null
  
)

export default component.exports